import React, { useState, useEffect } from "react";

import { getDiffDays } from "../../../shared/utils/dateUtilities";
import { likeComment } from "../../../services/tribe";

interface CommentResponseProps {
  id: string;
  user: {
    id: string;
    profile: any;
  };
  counts: any;
  summary: string;
  createdAt: string;
  upvotes: Array<any>;
  images: Array<any>;
  userId: string;
  userInfo: any;
  deleteHandler: any;
  handleNewCommentModal: any;
  setShowModalDelete: any;
  showModalDelete: any;
  editingCommentHandler: any;
}

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const CommentResponse = (props: CommentResponseProps) => {
  const {
    id,
    user,
    summary,
    createdAt,
    upvotes,
    counts,
    userId,
    userInfo,
  } = props;

  const [likeAvailable, setLikeAvailable] = useState(true);
  const [totalLikes, setTotalLikes] = useState(0);

  useEffect(() => {
    if (upvotes !== undefined) {
      setLikeAvailable(!props.upvotes.find((vote) => vote.id === userId));
    }
    if (counts.upvotes !== undefined) {
      setTotalLikes(counts.upvotes);
    }
  }, [id]);

  const likeAction = () => {
    likeComment(likeAvailable ? "LIKE" : "DISLIKE", id, userInfo.email);
    setLikeAvailable(!likeAvailable);
    setTotalLikes(likeAvailable ? totalLikes + 1 : totalLikes - 1);
  };

  const formatDate = (date: string) => {
    const today = new Date();
    const cd = date
      .split(" ")[0]
      .split("/")
      .map((cd) => parseInt(cd));
    const ct = date
      .split(" ")[1]
      .split(":")
      .map((ct) => parseInt(ct));
    const commentDate = new Date(cd[2], cd[1] - 1, cd[0], ct[0], ct[1], ct[1]);
    const daysDiff = getDiffDays(commentDate.toString(), today.toString());
    const hoursDiff = today.getHours() - commentDate.getHours();
    const minutesDiff = today.getMinutes() - commentDate.getMinutes();
    if (daysDiff > 7) {
      return cd[0] + " " + MONTHS[cd[1] - 1] + " " + cd[2];
    } else if (daysDiff > 0) {
      return daysDiff > 1 ? "Hace " + daysDiff + " días" : "Ayer";
    } else if (hoursDiff > 0) {
      return "Hace " + hoursDiff + (hoursDiff > 1 ? " horas" : " hora");
    } else if (minutesDiff > 0) {
      return "Hace " + minutesDiff + (minutesDiff > 1 ? " minutos" : " minuto");
    } else {
      return "Hace menos de 1 minuto";
    }
  };

  return (
    <div className="a-card-comment__comment-response">
      <img
        className="a-card-comment__comment-response__photo"
        src={user.profile.picture}
        alt={`Foto ${user.profile.name}`}
      />
      <div className="a-card-comment__comment-response__right">
        <div className="a-card-comment__comment-response__right__content">
          <p className="a-card-comment__comment-response__right__content__author">
            {user.profile.name}
          </p>
          <p className="a-card-comment__comment-response__right__content__text">
            {summary}
          </p>
          {props.images[0] && (
            <img
              className="a-card-comment__comment-response__right__content__image"
              src={props.images[0].src}
              alt={`Respuesta comentario ${user.profile.name} ${createdAt}`}
            />
          )}
        </div>
        <div className="a-card-comment__comment-response__right__info">
          <p className="a-card-comment__comment-response__right__info__date">
            {formatDate(createdAt)}
          </p>
          {user.id === userId && user.id !== "5fbfacc3dbf3e04c82adedd8" && (
            <div className="a-card-comment__likes-section__edit">
              <p
                className="a-card-comment__likes-section__edit-edit icon-edit"
                onClick={() => {
                  props.handleNewCommentModal(true);
                  props.editingCommentHandler(summary.slice(0, 300), props.id);
                }}
              ></p>

              <p
                className="a-card-comment__likes-section__edit-delete icon-trash-alt"
                id="modal-delete"
                onClick={() => {
                  props.deleteHandler(props.id);
                }}
              ></p>
            </div>
          )}
          <p
            className={`a-card-comment__comment-response__right__info__likes ${
              likeAvailable || !props.userInfo.email
                ? ""
                : "a-card-comment__comment-response__right__info__likes--liked"
            }`}
            onClick={props.userInfo.email && user.id !== userId ? () => likeAction() : () => false}
          >
            <i
              className={`a-card-comment__comment-response__right__info__likes__action ${
                  user.id === userId 
                  ? "a-card-comment__comment-response__right__info__likes__action--disabled" 
                  : ""
                } ${
                likeAvailable || !props.userInfo.email
                  ? "icon-thumbs-up"
                  : "icon-thumbs-up1"
              }`}
            />
            {totalLikes}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommentResponse;
